export const GLOBAL_NODE_ID_PREFIX = 'flow-global-starter';

export const isGlobalNode = (nodeId: string | undefined | null): boolean =>
  !!nodeId && nodeId.startsWith(GLOBAL_NODE_ID_PREFIX);
